import { useProperty, useTranslation } from '@eti/providers';
import { Stack } from '@etg/wings';
import TitledCard from '../../../../../common/components/TitledCard';
import PaymentDrawerButton from './PaymentDrawerButton';
import Invoice from './Invoice';
import Receipt from './Receipt';

const Payment = () => {
  const { t } = useTranslation();
  const { p } = useProperty();

  return (
    <TitledCard
      data-testid="payment-page-section"
      title={t('OrderDetails.Payment.Overview.Header')}
    >
      <Stack>
        <PaymentDrawerButton />
        {p('Invoice.Generation.Enabled') && <Invoice />}
        <Receipt
          hasIcon
          snowplow={{
            category: 'Overview',
            label: 'DOWNLOAD_RECEIPT',
          }}
        />
      </Stack>
    </TitledCard>
  );
};

export default Payment;
